/**
 * 其知创新 项目管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/index/index' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>项目管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.title" style="width:140px" placeholder="输入标题"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.author" style="width:140px" placeholder="输入作者"></el-input>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择发布开始时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择发布结束时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">发布</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="danger" icon="el-icon-delete" @click="delAllNew">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="80">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="sort" align="center" label="排序值" width="60" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="title" align="center" label="标题" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="author" align="center" label="作者" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="release_time" align="center" label="发布时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delNew(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="addTitle" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" ref="editForm" :model="editForm" :rules="addFormRules">
        <el-row>
            <el-form-item label="标题" prop="title">
              <el-input size="small" v-model="editForm.title" auto-complete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item label="内容" prop="content">
            <quill-editor ref="text" v-model="editForm.content" class="myQuillEditor" :options="editorOption" />
            </el-form-item> -->
            <el-form-item label="内容" prop="content">
              <div class="editor-wrapper">
                <quill-editor 
                  ref="text" 
                  v-model="editForm.content" 
                  class="myQuillEditor" 
                  :options="editorOption" 
                  @ready="onEditorReady"
                />
                <!-- 上传进度提示 -->
                <el-progress 
                  v-if="uploading" 
                  :percentage="uploadPercent" 
                  :status="uploadStatus"
                  :stroke-width="6"
                  style="width: 200px; margin-top: 10px;"
                />
              </div>
            <!-- <quill-editor ref="text" v-model="editForm.content" class="myQuillEditor" :options="editorOption" /> -->
            </el-form-item>
            <el-form-item label="作者" prop="author">
              <el-input size="small" v-model="editForm.author" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="发布时间" prop="release_time">
              <el-input size="small" v-model="editForm.release_time" auto-complete="off" placeholder="格式：2021-04-07"></el-input>
            </el-form-item>
            <el-form-item label="排序值" prop="sort">
              <el-input size="small" v-model="editForm.sort" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitEditNews('editForm')">发布</el-button>
              <el-button size="mini" type="warning" @click="submitViewNews('editForm')">预览</el-button>
              <el-button size="mini" @click='closeDialog("editForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { officeNewsList, officeNewsEdit, officeNewsDel, officeNewsDelCheck, officeNewsView } from '../../api/webMG'
import Pagination from '../../components/Pagination'

//引入ali-oss
import { client, getFileNameUUID } from '@/utils/ali-oss'

//引入富文本 start
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
// import imageResize from 'quill-image-resize-module' // 引用，调整图片大小
// 引入图片拖拽模块
import { ImageDrop } from 'quill-image-drop-module'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { checkLogin, getCurrentDate } from '../../utils/util'

import {regionData,CodeToText,provinceAndCityData} from 'element-china-area-data'

Quill.register('modules/ImageExtend', ImageExtend)
// 注册图片拖拽模块
Quill.register('modules/imageDrop', ImageDrop)
// Quill.register('modules/imageResize', imageResize)
//引入富文本 end

// const apiUrl = "http://192.168.0.158/index.php";
const apiUrl = "https://zlbb.qzhip.com/index.php";
export default {
  name: "Upload",
  props: {
    limit: {
    type: Number,
    default: 1
    }
    },
  data() {
    return {
       // 视频上传开始
      fileList: [],//文件列
      showProgress: false,//进度条的显示
      dataObj: {}, //存签名信息
      progress: 0, //进度条数据
      // 视频上传结束

      idShow: false,
      idCoverShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      dialogVisible: false, //控制预览图片显示与隐藏
      isVideo: false,
      isProvince: false,

      // 上传状态
      uploading: false,
      uploadPercent: 0,
      uploadStatus: null,

      selectedOptions: [],
      addtions:{},			//存储地址数据

      videoUrl: '', //视频地址
      productImgs: [],
      dialogImageUrl: '',
      isMultiple: true,
      title: '详情',
      addTitle: '发布',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      editorOption: {
        placeholder: "",
        // 图片拖拽模块
        imageDrop: {
          handler: this.handleImageDrop, // 处理拖拽/粘贴图片
        },

        modules: {
          ImageExtend: {
            loading: true,
            name: "file", //图片参数名
            size: 2, // 可选参数 图片大小，单位为M，1M = 1024kb
            action: "https://zlbb.qzhip.com/index.php/index/base/uploadFile", //上传的服务器地址，如果action为空，则采用base64插入图片
            // response 为一个函数，用来获取服务器返回的具体图片地址
            response: res => {
              console.log(res);
              const imgUrl = res.data.url;
              return imgUrl;
            },
            headers: xhr => {
              // 上传图片请求需要携带token的 在xhr.setRequestHeader中设置，这里我的token存放在sessionStorage中
              xhr.setRequestHeader(
                "Token",
                window.localStorage.getItem("token")
              );
            },
            // 可选参数 设置请求头部
            sizeError: () => {
              this.$message.error('图片大小不能超过2MB');
            }, // 图片超过大小的回调
            start: () => {
              this.uploading = true;
              this.uploadPercent = 0;
              this.uploadStatus = null;
            }, // 可选参数 自定义开始上传触发事件
            end: () => {
              this.uploadStatus = 'exception';
              this.$message.error('图片上传失败');
            }, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            error: () => {}, // 可选参数 上传失败触发的事件
            success: () => {
              this.uploadStatus = 'success';
              this.uploadPercent = 100;
              console.log('图片上传成功');
              // console.log("ImageExtend中的success：上传成功");
            }, // 可选参数  上传成功触发的事件
            change: (xhr, formData) => {
              // xhr.setRequestHeader('myHeader','myValue')
              // formData.append('token', 'myToken')
              // 监听上传进度
              xhr.upload.addEventListener('progress', (e) => {
                if (e.lengthComputable) {
                  const percentComplete = Math.round((e.loaded * 100) / e.total);
                  this.uploadPercent = percentComplete;
                }
              });
            } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
          },
          // 调整图片大小
          // imageResize: {
					// 	displayStyles: {
					// 		backgroundColor: 'black',
					// 		border: 'none',
					// 		color: 'white'
					// 	},
					// 	modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
					// },
          // 如果不上传图片到服务器，此处不必配置
          toolbar: {
            // container为工具栏，此次引入了全部工具栏，也可自行配置
            container: [
              ['bold', 'italic', 'underline', 'strike'],// 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'],// 引用，代码块
              [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
              [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
              [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
              [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
              [{ 'direction': 'rtl' }], // 文本方向
              [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
              [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
              [{ 'font': [] }], // 字体
              [{ 'align': [] }], // 对齐方式
              ['clean'], //清除字体样式
              ['link','image','video'] //上传图片、上传视频
            ],
            // 上传成功，回显图片（会进入如上面ImageExtend的各过程，返回<img src="http://xx.xx.xx.xx:xxxx/file/xxx.jpg">）
            handlers: {
              image: function() {
                // 劫持原来的图片点击按钮事件
                QuillWatch.emit(this.quill.id);
              }
            },
            // 剪贴板配置 - 处理粘贴事件
            clipboard: {
              matchers: [],
            }
          }
        }
      },
      editForm: {
        id: '',
        title: '',
        author: '',
        content: '',
        type: 1,
        sort: '',
        release_time: ''
      },
       formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        title: '',
        author: '',
        type: 1,
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      addFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        author: [
          { required: true, message: '请输入作者', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        release_time: [
          { required: true, message: '请输入发布时间', trigger: 'blur' }
        ]
      },

      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      // videoForm: {
      //     showVideoPath: ''
      // }


    }
  },
  // 注册组件
  components: {
    Pagination,
    quillEditor
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  mounted(){

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      officeNewsList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示编辑界面
    handleEdit: function(index, row){
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.addTitle = '编辑'
        this.editForm.id = row.id,
        this.editForm.title = row.title,
        this.editForm.author = row.author,
        this.editForm.content = row.content,
        this.editForm.sort = row.sort,
        this.editForm.release_time = row.release_time
      } else {
        this.addTitle = '发布'
        this.isProvince = false
        this.editForm.id = '',
        this.editForm.title = '',
        this.editForm.author = '',
        this.editForm.content = '',
        this.editForm.sort = '',
        this.editForm.release_time = ''
      }
    },
    // 编辑页面保存方法
    submitEditNews(editData) {
      //校验参数
      this.$refs[editData].validate(valid => {
        if(valid){
           officeNewsEdit(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '发布成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        }else{
          return false;
        }
      })
    },
    // 文章预览
    submitViewNews(editData) {
    //校验参数
    this.$refs[editData].validate(valid => {
      if(valid){
        officeNewsView(this.editForm)
          .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
              let id = res.data.id
              // 新页面跳转
              let link_url = "https://www.qzhip.cn/IndustryNews?id="+id
              window.open(link_url,'_blank')
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.$message.error('操作失败，请稍后再试！')
          })
      }else{
        return false;
      }
    })
    },
    // 删除文章
    delNew(index, row) {
    // 添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
      const delParam = {id:row.id}
      officeNewsDel(delParam)
      .then(res=>{
        this.loading = false
        console.log(res);
        res = checkLogin(res)
        if (res.code == 200) {
            this.$message({
                type: 'success',
                message: '删除成功'
          })
            this.getdata(this.formInline)
        } else {
            this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delAllNew(){
    // 判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
        //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除所有勾选的吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        const delParam = {ids:idStr}
        officeNewsDelCheck(delParam)
        .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
              this.$message({
                  type: 'success',
                  message: '删除成功'
            })
              this.getdata(this.formInline)
          } else {
              this.$message({
                  type: 'info',
                  message: res.msg
            })
          }
        })
        })
         .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },

    // 修改quill富文本图片上传开始

    // 编辑器准备就绪
    onEditorReady(quill) {
      // 监听粘贴事件
      quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        if (node.tagName === 'IMG') {
          // 获取图片
          const img = node;
          const src = img.src;
          
          // 如果是base64图片，上传到服务器
          if (src.startsWith('data:image')) {
            // 阻止默认的base64插入
            delta.ops = [];
            
            // 将base64转换为Blob
            const blob = this.dataURLtoBlob(src);
            const file = new File([blob], 'pasted-image.png', { type: 'image/png' });
            
            // 上传图片
            this.uploadPastedImage(file, quill).then(url => {
              if (url) {
                // 插入上传后的图片URL
                const range = quill.getSelection();
                quill.insertEmbed(range.index, 'image', url, Quill.sources.USER);
              }
            });
            
            return delta;
          }
        }
        return delta;
      });

      // 监听拖拽/粘贴文件事件
      quill.root.addEventListener('paste', this.handlePaste);
      quill.root.addEventListener('drop', this.handleDrop);
    },
    // 处理粘贴事件
    handlePaste(event) {
      const quill = this.$refs.text.quill;
      const clipboardData = event.clipboardData;
      
      if (clipboardData && clipboardData.items) {
        const items = clipboardData.items;
        
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.type.indexOf('image') !== -1) {
            event.preventDefault(); // 阻止默认粘贴行为
            
            const file = item.getAsFile();
            if (file) {
              this.uploadPastedImage(file, quill).then(url => {
                if (url) {
                  const range = quill.getSelection();
                  quill.insertEmbed(range.index, 'image', url, Quill.sources.USER);
                }
              });
            }
            break; // 只处理第一个图片
          }
        }
      }
    },
    // 处理拖拽事件
    handleDrop(event) {
      event.preventDefault();
      const quill = this.$refs.text.quill;
      const files = event.dataTransfer.files;
      
      if (files.length > 0) {
        const file = files[0];
        if (file.type.startsWith('image/')) {
          this.uploadPastedImage(file, quill).then(url => {
            if (url) {
              const range = quill.getSelection();
              if (!range) {
                // 如果没有选区，插入到编辑器末尾
                quill.insertEmbed(quill.getLength(), 'image', url);
              } else {
                quill.insertEmbed(range.index, 'image', url, Quill.sources.USER);
              }
            }
          });
        }
      }
    },
    // 图片拖拽模块的处理函数
    handleImageDrop(file, insert) {
      this.uploadPastedImage(file, this.$refs.text.quill).then(url => {
        if (url) {
          insert(url); // 使用模块提供的insert方法插入图片
        }
      });
    },

    // 上传粘贴的图片
    async uploadPastedImage(file, quill) {
      return new Promise((resolve, reject) => {
        this.uploading = true;
        this.uploadPercent = 0;
        this.uploadStatus = null;
        
        const formData = new FormData();
        formData.append('file', file);
        
        // 创建XMLHttpRequest以获取上传进度
        const xhr = new XMLHttpRequest();
        
        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) {
            const percentComplete = Math.round((e.loaded * 100) / e.total);
            this.uploadPercent = percentComplete;
          }
        });
        
        xhr.addEventListener('load', () => {
          try {
            const response = JSON.parse(xhr.responseText);
            if (response.code === 200 && response.data && response.data.url) {
              this.uploadStatus = 'success';
              this.uploadPercent = 100;
              setTimeout(() => {
                this.uploading = false;
              }, 500);
              resolve(response.data.url);
            } else {
              this.uploadStatus = 'exception';
              this.$message.error('图片上传失败: ' + (response.msg || '未知错误'));
              this.uploading = false;
              resolve(null);
            }
          } catch (error) {
            this.uploadStatus = 'exception';
            this.$message.error('图片上传失败');
            this.uploading = false;
            resolve(null);
          }
        });
        
        xhr.addEventListener('error', () => {
          this.uploadStatus = 'exception';
          this.$message.error('图片上传失败');
          this.uploading = false;
          resolve(null);
        });
        
        xhr.open('POST', 'https://zlbb.qzhip.com/index.php/index/base/uploadFile');
        xhr.setRequestHeader('Token', window.localStorage.getItem('token') || '');
        xhr.send(formData);
      });
    },
    // 将base64转换为Blob
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    beforeDestroy() {
    // 清理事件监听
      if (this.$refs.text && this.$refs.text.quill) {
        const quill = this.$refs.text.quill;
        quill.root.removeEventListener('paste', this.handlePaste);
        quill.root.removeEventListener('drop', this.handleDrop);
      }
    }

    // 修改quill富文本图片上传结束
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.editor-wrapper {
  position: relative;
}

/* 自定义Quill编辑器样式 */
.myQuillEditor {
  height: 400px;
}

.myQuillEditor ::v-deep .ql-container {
  height: calc(100% - 42px);
}

.myQuillEditor ::v-deep .ql-editor {
  min-height: 350px;
}

/* 上传进度样式 */
.upload-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/office/Projects.vue